import Component from '../core/Component'
import 'waypoints/lib/noframework.waypoints.js'
import debounce from 'lodash/debounce'

export default class ArticleDetail extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            content: null
        }

        this._queue = []
        this.logStart = Date.now()
        this.readingSpeed = 1000*60/220

        this.options = {
            url: this.element.getAttribute('data-url') || '',
            id: this.element.getAttribute('data-id'),
            words: parseInt(this.element.getAttribute('data-words')) || 0
        }

        this.save = debounce(::this.save, 200)

        this.waypoints = [];
    }

    prepare() {

        // article context

        new Waypoint({
            element: this.element,
            offset:  '50%',
            handler: direction => {
                if (direction == 'down') {
                    this.push({
                        type: 'read',
                        articleId: this.options.id,
                        time: Date.now(),
                        position: 0,
                        direction: direction,
                        words: this.options.words
                    });
                }
            }
        });

        new Waypoint({
            element: this.element,
            offset: 0,
            handler: direction => {
                if (direction === 'up') {
                    this.push({
                        type: 'read',
                        articleId: this.options.id,
                        time: Date.now(),
                        position: 0,
                        direction: direction,
                        words: this.options.words
                    });
                }
            }
        });

        // article content context

        if (this.ref.content) {
            new Waypoint({
                element: this.ref.content,
                offset: () => -this.ref.content.offsetHeight * 1/4 + window.innerHeight,
                handler: direction => {
                    this.push({
                        type: 'read',
                        articleId: this.options.id,
                        time: Date.now(),
                        position: 25,
                        direction: direction,
                        words: this.options.words
                    });
                }
            });

            new Waypoint({
                element: this.ref.content,
                offset: () => -this.ref.content.offsetHeight * 2/4 + window.innerHeight,
                handler: direction => {
                    this.push({
                        type: 'read',
                        articleId: this.options.id,
                        time: Date.now(),
                        position: 50,
                        direction: direction,
                        words: this.options.words
                    });
                }
            });

            new Waypoint({
                element: this.ref.content,
                offset: () => -this.ref.content.offsetHeight * 3/4 + window.innerHeight,
                handler: direction => {
                    this.push({
                        type: 'read',
                        articleId: this.options.id,
                        time: Date.now(),
                        position: 75,
                        direction: direction,
                        words: this.options.words
                    });
                }
            });

            new Waypoint({
                element: this.ref.content,
                offset: 'bottom-in-view',
                handler: direction => {
                    if (direction == 'down') {
                        const delay = this.readingSpeed * this.options.words;

                        setTimeout(() => {
                            this.push({
                                type: 'read',
                                articleId: this.options.id,
                                time: Date.now(),
                                position: 100,
                                direction: direction,
                                words: this.options.words
                            });
                        }, Date.now() - this.logStart < 100 ? delay : 0);
                    }
                }
            });
        }

    }

    destroy() {
        const context = Waypoint.Context.findByElement(this.element);
        context.destroy();
    }

    save() {
        const queue = [...this._queue];
        this._queue = [];

        $.ajax({
            url: this.options.url,
            data: {
                triggers: queue
            }
        });
    }

    push(value) {
        this._queue.push(value);
        this.save();
    }

}